import { render, staticRenderFns } from "./DlgRecordPlayer.vue?vue&type=template&id=cb6b29b2&scoped=true&"
import script from "./DlgRecordPlayer.vue?vue&type=script&lang=js&"
export * from "./DlgRecordPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DlgRecordPlayer.vue?vue&type=style&index=0&id=cb6b29b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b29b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
